// Calls to the FastAPI analysis backend (same origin, proxied at /api).
import type { Analysis } from "../types/domain";

export async function analyzeFile(file: File): Promise<Analysis> {
  const fd = new FormData();
  fd.append("file", file);
  const res = await fetch("/api/analyze", { method: "POST", body: fd });
  if (!res.ok) throw new Error(`분석 실패 (${res.status})`);
  return res.json();
}

export interface YouTubeQueued { queued: true; job_id: string; video_id: string }
export type YouTubeResult = (Analysis & { video_id: string; cached?: boolean }) | YouTubeQueued;

export async function analyzeYouTube(url: string): Promise<YouTubeResult> {
  const res = await fetch("/api/analyze_youtube", {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ url }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || `분석 실패 (${res.status})`);
  return data;
}

// poll a queued YouTube job until the local worker posts the analysis (or it errors / times out)
export async function pollYtJob(
  jobId: string, onTick?: (status: string) => void, timeoutMs = 180000,
): Promise<Analysis & { video_id: string }> {
  const t0 = Date.now();
  while (Date.now() - t0 < timeoutMs) {
    await new Promise((r) => setTimeout(r, 2000));
    let data: any;
    try {
      const res = await fetch(`/api/yt_jobs/${jobId}`);
      data = await res.json();
    } catch { continue; }   // transient network hiccup → keep polling
    if (data.status === "done") return data.result;
    if (data.status === "error") throw new Error(data.error || "분석 실패");
    onTick?.(data.status || "pending");
  }
  throw new Error("분석 시간이 초과되었습니다. 잠시 후 다시 시도해 주세요.");
}
